import React from 'react';
import { PageLayout } from '../../../shared/layout/page/PageLayout';
import { PageHeader } from '../../../shared/components';
import { AccountDetailsFormContainer } from './AccountDetailsFormContainer';
import { IAccountDetailsPageData } from '../../domain/pages/IAccountDetailsPageData';
import { DeleteAccountDialog } from '../../../auth/delete-account/ui/DeleteAccountDialog';

interface IAccountDetailsPageProps extends IAccountDetailsPageData {}

export const AccountDetailsPage = ({ page }: IAccountDetailsPageProps) => (
	<PageLayout page={page}>
		<PageHeader page={page} />
		<AccountDetailsFormContainer />
		<DeleteAccountDialog />
	</PageLayout>
);
